export { Actions } from '@ngrx/effects';

export { ISafariObjectState, SafariReduxApiObject } from '@safarilaw-webapp/shared/redux';
export { RmsDefaultPageReduxUiObject } from './default-page-ui-state';
export { IRmsUiState } from './state.interface';
export { RmsUiReducerService } from './state.reducer';

export const PROJECT_NAME = 'Rms';
